import { EmptyObject } from 'lib/object/objectUtils'

/**
 * @dev this is a placeholder for the loyalty item view. Please talk to the loyalty team before
 * updating this or replacing it in the relevant item view.
 */
export const EMPTY_LOYALTY_ITEM_VIEW: App.Checkout.LoyaltyItemView = EmptyObject
